import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63e9c4de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-10 capitalize" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opacity-50" }, "Via", -1 /* HOISTED */))
const _hoisted_3 = { class: "opacity-50 mb-2" }
const _hoisted_4 = {
  key: 0,
  class: "p-2 rounded-md bg-white bg-opacity-10 inline-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full m-2 p-4 rounded-md border border-white border-opacity-30 text-[16px] cursor-pointer", { active: _ctx.selected }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.name), 1 /* TEXT */)
    ]),
    _createTextVNode(" Est. " + _toDisplayString(_ctx.time) + " ", 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.description), 1 /* TEXT */),
    (_ctx.fee)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.fee), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}